export default __webpack_public_path__ + "static/media/CarImages.SonetLarge.9387bc75.jpg";